import { Clock, ChevronsDown, MousePointerClick, Download, PlayCircle } from 'lucide-preact'
import { memo } from 'preact/compat'
import type { AnalyticsMetricDto } from '@/types/analytics'
import { AnalyticsStatTile } from '../AnalyticsStatTile'

interface Props {
  metric: AnalyticsMetricDto | null
  loading: boolean
  error: string | null
}

// Engagement metric tiles (ORB-374 · M2), shared by the Campaign and Workspace dashboards.
// Each is a thin label/icon wrapper around the shared AnalyticsStatTile — matching the M1
// VisitorMetricTiles — so values, loading/error states, and theming stay consistent. Time-on-page
// renders as a duration, max scroll as a percent; the interaction tiles are plain counts.

const iconClass = 'w-5 h-5 text-primary-600 dark:text-primary-400'

export const AvgTimeOnPageStatTile = memo(({ metric, loading, error }: Props) => (
  <AnalyticsStatTile
    title={<><span className="block">Avg Time</span><span className="block">on Page</span></>}
    icon={<Clock className={iconClass} />}
    metric={metric}
    loading={loading}
    error={error}
    format="duration"
  />
))

export const MaxScrollDepthStatTile = memo(({ metric, loading, error }: Props) => (
  <AnalyticsStatTile
    title={<><span className="block">Avg Max</span><span className="block">Scroll</span></>}
    icon={<ChevronsDown className={iconClass} />}
    metric={metric}
    loading={loading}
    error={error}
    format="percent"
  />
))

export const CtaClicksStatTile = memo(({ metric, loading, error }: Props) => (
  <AnalyticsStatTile
    title={<><span className="block">CTA</span><span className="block">Clicks</span></>}
    icon={<MousePointerClick className={iconClass} />}
    metric={metric}
    loading={loading}
    error={error}
  />
))

export const DownloadClicksStatTile = memo(({ metric, loading, error }: Props) => (
  <AnalyticsStatTile
    title={<><span className="block">Download</span><span className="block">Clicks</span></>}
    icon={<Download className={iconClass} />}
    metric={metric}
    loading={loading}
    error={error}
  />
))

export const VideoPlaysStatTile = memo(({ metric, loading, error }: Props) => (
  <AnalyticsStatTile
    title={<><span className="block">Video</span><span className="block">Plays</span></>}
    icon={<PlayCircle className={iconClass} />}
    metric={metric}
    loading={loading}
    error={error}
  />
))
